export default __webpack_public_path__ + "static/media/rare1.f9b52708.png";